<template>
<v-flex>
    <v-flex xs12 :class="['chapter_banner', !hasSystemMessage && 'chapter_banner--no-system-message',  routeConfigHideHeader && 'no-header-layout']">
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <Breadcrumb></Breadcrumb>
            <div class="community_title">
                <div class="community_title__name" v-if="isVisible"
                        data-qe-id="chapter-banner_community-name">
                    {{communityName}}
                </div>
            </div>
        </v-flex>
        <v-flex xs12 sm4 class="banner_view__options">

        <v-flex class="awards_block hidden-xs" v-if="isChapterPage && hasCommunityIdInRoute && communityName !== communityCommonConstant.YPO_Atlas">
            <v-flex>
                <span>
                    {{homeBanner.CHAPTER_HEALTH}}
                    <strong data-qe-id="chapter-banner_community_health-score">{{getChapterHealthScore}}</strong>
                </span>
                <img v-if="getChapterHealthScore !== communityCommonConstant.THIS_CHAPTER_DOES_NOT_MEET_THE_MINIMUM_STANDARDS && getChapterHealthScore !== communityCommonConstant.No_Ranking"
                     src="../../assets/trophy.png" />
            </v-flex>
            </v-flex>
            <admin-view-option v-if="isChapterPage && isCommunityAdmin" class="admin-tab">
            </admin-view-option>
        </v-flex>
        </v-layout>
        </v-flex>
</v-flex>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { routerNames, homeBanner, userRoles } from "../appCommon.constants";
    import { Administration } from "../NetworkPage/NetworkConstants";
    import AdminViewOption from '../AdminViewOption/AdminViewOption';
    import Breadcrumb from "../Layout/Breadcrumb";
    import { communityCommonConstant } from "./communityCommon.constant";

    export default {
        name: 'ChapterBanner',
        components: {
            AdminViewOption,
            Breadcrumb,
        },
        created() {
            if ((this.isRegionPage || this.isChapterPage) && !this.allChapterList) {
                this.getAllChapterList();
            }
        },
        data: () => ({
            myCommunity: '',
            items: [],
            homeBanner,
            userRoles,
            communityCategory: '',
            Administration,
            communityCommonConstant,
        }),
        methods: {
            ...mapActions({
                getChapterList: `chapter/${storeAction.getChapterList}`,
                getAllChapterList: `chapter/${storeAction.getAllChapterList}`,
            }),
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                isCommunityAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                currentCommunityView: `${[storeGetters.currentCommunityView]}`,
                communityIdPromise: `${[storeGetters.communityIdPromise]}`,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
                getChapterHealthScore: `chapter/${[storeGetters.getChapterHealthScore]}`,
                allChapterList: `chapter/${storeGetters.allChapterList}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                systemMessages: `notification/${storeGetters.systemMessages}`,
                routeConfigHideHeader: `${[storeGetters.routeConfigHideHeader]}`,
                routeConfigEngagementApp: `${[storeGetters.routeConfigEngagementApp]}`,
            }),
            hasCommunityIdInRoute() {
                return !!this.$route.params.communityId;
            },
            isChapterPage() {
                return this.$route.name === routerNames.CHAPTER;
            },
            isRegionPage() {
                return this.$route.name === routerNames.REGION;
            },
            isEnrollmentType() {
                return this.communityInfo ? this.communityInfo.enrollmentMethod : '';
            },
            ExistNetwork() {
                return this.usersCommunitiesList && this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId);
            },
            communityName() {
                return this.communityInfo ? this.communityInfo.name : '';
            },
            isVisible() {
                return this.$route.params.communityId !== undefined;
            },
            isAdminView() {
                return this.currentCommunityView === this.userRoles.ADMIN;
            },
             linkTarget() {
                return this.isMobileAppBrowser ? '_self' : '_blank';
            },
            hasSystemMessage() {
              if (this.systemMessages && !this.routeConfigEngagementApp) {
                return this.systemMessages.length > 0;
              }
              return false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .chapter_banner {
        background: url(../../assets/ypo-banner.jpg);
        position: relative;
        min-height: 150px;
        background-size: cover;
        background-position: center;
        margin-top: 64px;

        @include breakpoint(xs) {
            margin-top: 125px;
        }

        &--no-system-message {
          @include breakpoint(xs) {
            margin-top: 100px;
          }
        }

        &:before {
            content: '';
            background: rgba($ypo_blue, 0.5);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .awards_block {
            position: absolute;
            right: 29px;
            top: 20px;
            z-index: 1;
            text-align: right;
            font-size: 12px;
            color: $white;
            font-family: 'Raleway', sans-serif;

            span {
                float: left;
                padding-top: 12px;
                font-size: 10px;
            }

            strong {
                display: block;
                font-size: 14px;
                font-weight: 500;
            }

            img {
                max-width: 28px;
                float: right;
                margin-left: 3px;
            }
        }

        .admin-tab {
            margin-top: 70px;
            @include breakpoint(xs) {
                margin-top: 0px;
            }
        }
    }
</style>
